<ng-container *transloco="let t; prefix: 'orders.customerConfiguration'">
  @if (customer(); as company) {
    <mat-card class="customer-summary" appearance="outlined">
      <mat-card-content class="customer-summary-content">
        <span class="customer-summary-name headline-small-emphasized">{{ company.ragioneSociale }}</span>
        <div class="customer-summary-field">
          <span class="body-large-emphasized">{{ t('taxCode') }}</span>
          <span class="body-large">{{ company.codiceFiscale || '—' }}</span>
        </div>
        <div class="customer-summary-field">
          <span class="body-large-emphasized">{{ t('vatNumber') }}</span>
          <span class="body-large">{{ company.partitaIva || '—' }}</span>
        </div>
      </mat-card-content>
    </mat-card>

    <div class="order-notes-heading">
      <span class="title-medium-emphasized">{{ t('orderNotesTitle') }}</span>
      <a matButton [routerLink]="['/new-order-proposal/configure-customer/banking']" [queryParams]="{ id: proposalId }">{{ t('backToBanking') }}</a>
    </div>

    <form class="order-notes-form" [formGroup]="form" (ngSubmit)="continue()">
      <div class="order-notes-fields">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ t('orderNoteTitle') }}</mat-label>
          <input matInput formControlName="title">
        </mat-form-field>
        <mat-form-field class="order-note-text text-area-custom" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ t('orderNoteText') }}</mat-label>
          <textarea matInput formControlName="text" rows="5"></textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ t('orderNoteDate') }}</mat-label>
          <input matInput formControlName="date" [matDatepicker]="noteDatePicker">
          <mat-datepicker-toggle matIconSuffix [for]="noteDatePicker" disabled></mat-datepicker-toggle>
          <mat-datepicker #noteDatePicker disabled></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="authorization-note">
        <span class="authorization-note-title body-large-emphasized">{{ t('authorizationNoteTitle') }}</span>
        <span class="body-large">{{ t('authorizationNoteDescription') }}</span>
        <mat-slide-toggle formControlName="addToAuthorization" [aria-label]="t('authorizationNoteTitle')"></mat-slide-toggle>
      </div>

      <div class="order-notes-actions">
        <button matButton="filled" type="submit" [disabled]="!configuration.destinationForConfiguration()">{{ t('continue') }}</button>
      </div>
    </form>
  } @else {
    <div class="order-notes-state">
      <span class="body-large">{{ t('missingCustomer') }}</span>
      <a matButton="outlined" [routerLink]="['/new-order-proposal/new-customer']" [queryParams]="{ id: proposalId }">{{ t('backToSearch') }}</a>
    </div>
  }
</ng-container>
